import { Pipe, PipeTransform, Injectable} from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Pipe({
    name: 'currentLang'
})
@Injectable({
    providedIn: 'root'
})
export class CurrentLangPipe implements PipeTransform {

    constructor(private cookieService: CookieService) {}

    private _langs: Array<string> = ['ru', 'kk', 'en'];

    transform(descriptor: string): string {
        let currentlocale: string = this.obtain();
        if ((currentlocale == null) || (this._langs.indexOf(currentlocale) < 0)) {
            return this.set('ru');
        }
        return currentlocale;
    }

    next(): Promise<string> {
        let currentlocale: string = this.obtain();
        if ((currentlocale == null) || (this._langs.indexOf(currentlocale) < 0)) {
            return Promise.resolve(this.set('ru'))
        }
        return Promise.resolve(currentlocale);
    }

    get(): string {
        let currentlocale: string = this.obtain();
        if ((currentlocale == null) || (this._langs.indexOf(currentlocale) < 0)) {
            return this.set('ru');
        }
        return currentlocale;
    }

    changeTo(to: string): Promise<string> {
        return Promise.resolve(this.set(to));
    }

    private obtain(): string {
        try {
            let _obtained = atob(this.cookieService.get(
                '.AspNetCore.SecurityModule.' + btoa('currentlocale').replace('==', '')
            ))
            return _obtained;
        } catch(err) {
            return this.set('ru')
        }
    }

    private set(to: string): string {
        this.cookieService.set(
            '.AspNetCore.SecurityModule.' + btoa('currentlocale').replace('==', ''),
            btoa(to)
        );
        return to;
    }

}